/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  function disableBroadcastOpenOnAdd() {
    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartDrawer || !cartDrawer.openCartDrawerOnProductAdded) return;

    document.removeEventListener('theme:product:added', cartDrawer.openCartDrawerOnProductAdded);
  }

  function unlockThemeScrollProperly() {
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
  }

  function handleAddToCartForUpCart() {
    // In case Broadcast locked scroll just before listener removal or via a race condition
    setTimeout(unlockThemeScrollProperly, 50);
    setTimeout(unlockThemeScrollProperly, 250);
    setTimeout(unlockThemeScrollProperly, 700);
  }

  function initUpcartBroadcastFix() {
    disableBroadcastOpenOnAdd();

    // Re-run in case Shopify or app scripts re-render parts of the page
    document.addEventListener('shopify:section:load', disableBroadcastOpenOnAdd);
    document.addEventListener('shopify:section:reorder', disableBroadcastOpenOnAdd);

    // Safety unlock after add-to-cart completes
    document.addEventListener('theme:product:added', handleAddToCartForUpCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initUpcartBroadcastFix);
  } else {
    initUpcartBroadcastFix();
  }
})();










document.addEventListener('theme:variant:change', function (e) {
  setTimeout(function () {
    const container = e.target;
    const variant = e.detail && e.detail.variant;
    if (!container || !variant) return;

    const compareEl = container.querySelector('[data-compare-price]');
    const compareWrap = container.querySelector('[data-compare-price-wrap]');
    const compareTextEl = container.querySelector('[data-compare-text]');
    const productPriceEl = container.querySelector('[data-product-price]');

    if (!compareEl || !compareWrap) return;

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      compareWrap.classList.remove('hidden');
      compareEl.innerHTML = window.theme.formatMoney(variant.compare_at_price, theme.moneyFormat);

      if (compareTextEl) compareTextEl.classList.add('hidden');
      if (productPriceEl) productPriceEl.classList.add('product__price--sale');
    } else {
      compareWrap.classList.add('hidden');
      compareEl.innerHTML = '';

      if (productPriceEl) productPriceEl.classList.remove('product__price--sale');
    }
  }, 0);
});